/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetVectorStoreRequest = {
  vectorStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetVectorStoreRequest$inboundSchema: z.ZodType<
  GetVectorStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  vector_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "vector_store_id": "vectorStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetVectorStoreRequest$Outbound = {
  vector_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetVectorStoreRequest$outboundSchema: z.ZodType<
  GetVectorStoreRequest$Outbound,
  z.ZodTypeDef,
  GetVectorStoreRequest
> = z.object({
  vectorStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    vectorStoreId: "vector_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getVectorStoreRequestToJSON(
  getVectorStoreRequest: GetVectorStoreRequest,
): string {
  return JSON.stringify(
    GetVectorStoreRequest$outboundSchema.parse(getVectorStoreRequest),
  );
}
export function getVectorStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetVectorStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetVectorStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetVectorStoreRequest' from JSON`,
  );
}
